import { render, staticRenderFns } from "./ActivitySummary.vue?vue&type=template&id=23d9876f"
import script from "./ActivitySummary.vue?vue&type=script&lang=js"
export * from "./ActivitySummary.vue?vue&type=script&lang=js"
import style0 from "./ActivitySummary.vue?vue&type=style&index=0&id=23d9876f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports